import React from "react";

import type { BoxProps } from "@braintrust/braintrust-ui-components";
import { Box, RoundedBox } from "@braintrust/braintrust-ui-components";
import { JobTypeTag, RolesTag } from "@js/apps/jobs/components";
import { JobSectionTitle } from "@js/apps/jobs/components/job-section-title";
import type { Role } from "@js/types/roles";

import style from "./style.module.scss";

type RoleAndJobTypeBoxProps = BoxProps & {
  jobType: EnumType<typeof ENUMS.JobType>;
  jobRole: Role;
};

export const RoleAndJobTypeBox = ({
  jobType,
  jobRole,
  ...props
}: RoleAndJobTypeBoxProps) => {
  return (
    <RoundedBox {...props} sx={{ height: "100%", ...props.sx }}>
      <Box
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <JobSectionTitle>Role and Job Type</JobSectionTitle>
      </Box>
      <Box className={style.skillsWrapper}>
        <RolesTag role={jobRole} />
        <JobTypeTag type={jobType} />
      </Box>
    </RoundedBox>
  );
};
